/*
EVENT_ID: 1
PRODUCER: ProctoringEnvironment, SpeechAce-ProctoringEnvironment
CONSUMER: VideoChuckUploader
EVENT_NAME: trigger_end_test_video_stream_uploader
*/
export const trigger_end_test_video_stream_uploader = "trigger_end_test_video_stream_uploader";
/*
EVENT_ID: 2
PRODUCER: BotInterview, SpeechProctoringEnvironment
CONSUMER: VideoChuckUploader
EVENT_NAME: trigger_each_question_start_video_stream_uploader
*/
export const trigger_each_question_start_video_stream_uploader = "trigger_each_question_start_video_stream_uploader";
